import React from 'react';
import { RaceStatus } from '../types';
import { useTheme } from '../../../context/ThemeContext';

interface RaceTimerProps {
  raceStatus: RaceStatus;
  elapsedTime: number;
  buoysRounded: number;
  totalBuoys: number;
}

export const RaceTimer: React.FC<RaceTimerProps> = ({
  raceStatus,
  elapsedTime,
  buoysRounded,
  totalBuoys,
}) => {
  const { isDarkMode } = useTheme();

  if (raceStatus === 'notStarted') return null;

  const formatTime = (ms: number) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const centiseconds = Math.floor((ms % 1000) / 10);
    return `${minutes}:${seconds.toString().padStart(2, '0')}.${centiseconds
      .toString()
      .padStart(2, '0')}`;
  };

  return (
    <div
      className={`absolute top-4 right-4 mr-32 p-4 rounded-lg ${
        isDarkMode ? 'bg-gray-900/80 text-white' : 'bg-white/85 text-gray-800'
      }`}
    >
      <div className="font-mono text-2xl font-bold">{formatTime(elapsedTime)}</div>
      <div className="text-sm mt-1">
        Buoys: {buoysRounded}/{totalBuoys}
      </div>
      {raceStatus === 'finished' && (
        <div className="text-green-500 font-bold mt-2">FINISHED!</div>
      )}
    </div>
  );
};
